import { RequestKind, boolean, number, string } from '@sb/library/base';
import {
    ApplyPayrollSettingsUpdateItem,
    CashAttachmentInputItem,
    DisplayItemCollection,
    IDResultItem,
    PayrollAttachmentDisplayItem,
    PayrollDisplayItem,
    PayrollInputItem,
    PayrollSearchOptions,
    PayrollSummarySearchOptions,
    PayrollUpdateItem,
    TeacherPayrollOverrideDisplayItem,
    TeacherPayrollOverrideInputItem,
    TeacherPayrollOverrideSearchOptions,
    TeacherPayrollOverrideUpdateItem
} from '@sb/library/data-models';
import { ApiRoute } from '../api-route';

export namespace PayrollRoutes {
    export const Get = ApiRoute.Define({
        URL: (payrollID: string) => `payrolls/${payrollID}`,
        Kind: RequestKind.Get,
        ResultType: PayrollDisplayItem
    });

    export const ApplySettings = ApiRoute.Define({
        URL: 'payrolls',
        Kind: RequestKind.Patch,
        BodyType: ApplyPayrollSettingsUpdateItem,
        ResultType: boolean
    });

    export const Search = ApiRoute.Define({
        URL: 'search/payrolls',
        Kind: RequestKind.Post,
        BodyType: PayrollSearchOptions,
        ResultType: DisplayItemCollection<PayrollDisplayItem>,
        PagingAllowed: true
    });

    export const Add = ApiRoute.Define({
        URL: 'payrolls',
        Kind: RequestKind.Post,
        BodyType: PayrollInputItem,
        ResultType: string
    });

    export const Delete = ApiRoute.Define({
        URL: (payrollID: string) => `payrolls/${payrollID}`,
        Kind: RequestKind.Delete,
        ResultType: boolean
    });

    export const Update = ApiRoute.Define({
        URL: (payrollID: string) => `payrolls/${payrollID}`,
        Kind: RequestKind.Put,
        BodyType: PayrollUpdateItem,
        ResultType: string
    });

    export const GetSummary = ApiRoute.Define({
        URL: 'summary/payroll/sum',
        Kind: RequestKind.Post,
        BodyType: PayrollSummarySearchOptions,
        ResultType: number
    });

    export namespace Attachments {
        export const Add = ApiRoute.Define({
            URL: (payrollID: string) => `payroll/${payrollID}/attachments`,
            Kind: RequestKind.Post,
            BodyType: CashAttachmentInputItem,
            ResultType: string
        });

        export const Delete = ApiRoute.Define({
            URL: (attachmentID: string) => `payrollattachments/${attachmentID}`,
            Kind: RequestKind.Delete,
            ResultType: boolean
        });

        export const GetAll = ApiRoute.Define({
            URL: (payrollID: string) => `payroll/${payrollID}/attachments`,
            Kind: RequestKind.Get,
            ResultType: DisplayItemCollection<PayrollAttachmentDisplayItem>
        });
    }

    export namespace Override {
        export const Search = ApiRoute.Define({
            URL: 'search/teacherpayrolloverrides/',
            Kind: RequestKind.Post,
            BodyType: TeacherPayrollOverrideSearchOptions,
            ResultType: DisplayItemCollection<TeacherPayrollOverrideDisplayItem>
        });

        export const Add = ApiRoute.Define({
            URL: 'teacherpayrolloverrides/',
            Kind: RequestKind.Post,
            BodyType: TeacherPayrollOverrideInputItem,
            ResultType: string
        });

        export const Get = ApiRoute.Define({
            URL: (teacherID: string, eventCategoryID: string) => `teachers/${teacherID}/eventcategories/${eventCategoryID}/teacherpayrolloverrides`,
            Kind: RequestKind.Get,
            ResultType: TeacherPayrollOverrideDisplayItem
        });

        export const Update = ApiRoute.Define({
            URL: (teacherID: string, eventCategoryID: string) => `teachers/${teacherID}/eventcategories/${eventCategoryID}/teacherpayrolloverrides`,
            Kind: RequestKind.Put,
            BodyType: TeacherPayrollOverrideUpdateItem,
            ResultType: boolean
        });

        export const Delete = ApiRoute.Define({
            URL: (teacherID: string, eventCategoryID: string) => `teachers/${teacherID}/eventcategories/${eventCategoryID}/teacherpayrolloverrides/`,
            Kind: RequestKind.Delete,
            ResultType: boolean
        });
    }
}
